// extracted by mini-css-extract-plugin
module.exports = {"table":"MittTable_table__YMhs3","selectable":"MittTable_selectable___clNS","compact":"MittTable_compact__aWxhB"};